import { type RootContainerProps } from "@client/content/types";
import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, makeTextStyleSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const disclaimerSelector = getSettingValueSelector(TargetSelector.Entity, "title", "popup.disclaimer");
  const textStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "popup.disclaimer");
  const disclaimerHorizontalAlignSelector = getSettingValueSelector(
    TargetSelector.Entity,
    "horizontalAlign",
    "popup.disclaimer"
  );

  return (state: AppState, props: RootContainerProps): MapProps & WithIsVisibleHOCProps => {
    const title = disclaimerSelector(state, props);

    return {
      ...props,
      isVisible: !!title,
      horizontalAlign: disclaimerHorizontalAlignSelector(state, props),
      textStyle: textStyleSelector(state, props),
      title
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
